import React from 'react'
import './Answerpopupcdmqb.css'
// All classNames are suffixed with "CDMQB" so they never collide with the
// default skin's CSS if that stylesheet happens to be loaded too.

export default function AnswerPopupCDMQB(props) {

    const getMultipleChoiceOption = (optionIndex, questionId) => {
		let answer
		props.simulationData.ao.forEach((answerValue, answerIndex) => {
			if (answerValue.ANSWERID === optionIndex) {
				answer = answerValue.ANSWER
			}
		})
		return answer
	}

    return (
        <div className='answerPopupPageWrapperCDMQB'>
            <div className='answerPopupBackdropCDMQB' />
            <div className='answerPopupContainerCDMQB'>
                <div className='answerPopupHeaderContainerCDMQB'>
                    <p className='answerPopupHeaderTextCDMQB'>Correct Answers for question {props.currentQuestion}</p>
                </div>
                <div className='answerPopupBodyContainerCDMQB'>
                    <div className='grading-feedback-categoryCDMQB' key={`gradingCategory${props.currentQuestion - 1}`}>
                        <div className='grading-feedback-category-headerCDMQB'>
                            Question {props.currentQuestion} ({props.gradeOutput[0].grade ? `${props.gradeOutput[0].grade.toFixed(2)}%` : '0%'})
                        </div>
                            <div className={`grading-feedback-eventCDMQB userEntryCDMQB`}>
                                <div className='grading-feedback-event-headerCDMQB'>Your answer</div>
                                <ul>
                                    {props.gradeOutput[0].PreviousInput[0].CustomerAnswersBlank ? props.gradeOutput[0].PreviousInput[0].CustomerAnswersBlank.map((inputValue, inputIndex) => (
                                        <li key={`Question${props.currentQuestion - 1}Answer${inputIndex}`}>{inputValue === "" ? <b>Option left blank</b> : inputValue}</li>
                                    ))
                                    : props.gradeOutput[0].PreviousInput[0].CustomerAnswerMC.map((inputValue, inputIndex) => (
                                        <li key={`Question${props.currentQuestion - 1}Answer${inputIndex}`}>{getMultipleChoiceOption(inputValue, props.gradeOutput[0].QuestionId)}</li>
                                    ))}
                                </ul>
                            </div>
                            {props.gradeOutput[0].GradeOut.map((gradedValue, gradedIndex) => (
                                <div key={`GradeResult${props.currentQuestion - 1}-${gradedIndex}`} className={`grading-feedback-eventCDMQB ${gradedValue.GradeColor === 'Correct - Green' ? 'correctCDMQB' : gradedValue.GradeColor === 'Neutral - Blue' ? 'optionalCDMQB' : 'incorrectCDMQB'}`}>
                                    <div className='grading-feedback-event-headerCDMQB'>{gradedValue.EventName}</div>
                                    <ul>
                                        <li>{gradedValue.OrderName}</li>
                                    </ul>
                                    <div><span className='grading-feedback-event-reasonCDMQB'>{'Reason: '}</span>{gradedValue.Explanation}</div>
                                </div>
                            ))}
                    </div>
                </div>
                <div className='answerPopupFooterContainerCDMQB'>
                    <button className='answerPopupFooterButtonCDMQB' onClick={props.continueCase}>{((props.currentQuestion === props.simulationData.answerList.length) || props.caseEnded) ? 'Complete Case' : 'Next Question'}</button>
                </div>
            </div>
        </div>
    )
}